import React from 'react';
import '../Style/videobenefits.css';

const icons = {
  storytelling: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M3 5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 3v4a1 1 0 0 0 1 1h4M8 12h8M8 16h5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  reach: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <circle cx="12" cy="12" r="3" />
      <circle cx="4.5" cy="6" r="2" />
      <circle cx="19.5" cy="6" r="2" />
      <circle cx="4.5" cy="18" r="2" />
      <circle cx="19.5" cy="18" r="2" />
      <path d="M9.8 10.3 6.2 7.4M14.2 10.3l3.6-2.9M9.8 13.7l-3.6 2.9M14.2 13.7l3.6 2.9" strokeLinecap="round" />
    </svg>
  ),
  engagement: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M20.8 8.6c0-2.4-2-4.2-4.3-4.2-1.6 0-3 .9-3.7 2.2C12.1 5.3 10.7 4.4 9 4.4c-2.3 0-4.3 1.8-4.3 4.2 0 5 7.6 9.4 7.6 9.4s7.5-4.3 7.5-9.4Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  conversions: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M3 17 9.5 10.5 13.5 14.5 21 7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 7h6v6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  growth: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M13 3 4 14h7l-1 7 9-11h-7l1-7Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

const benefits = [
  {
    id: 1,
    icon: 'storytelling',
    title: 'Strong Brand Storytelling',
    description: 'Professional videos help communicate your brand message clearly and emotionally, creating a strong and memorable brand identity.',
  },
  {
    id: 2,
    icon: 'reach',
    title: 'Better Audience Reach',
    description: 'Video content performs across platforms like YouTube, Instagram, and websites, helping you reach a wider audience.',
  },
  {
    id: 3,
    icon: 'engagement',
    title: 'Higher Customer Engagement',
    description: 'Engaging visuals and storytelling capture attention quickly, encouraging viewers to interact, share, and connect with your brand.',
  },
  {
    id: 4,
    icon: 'conversions',
    title: 'Increased Conversions & Sales',
    description: 'Well-crafted videos influence buying decisions by showcasing your products or services effectively, leading to higher conversions.',
  },
  {
    id: 5,
    icon: 'growth',
    title: 'Competitive Business Growth',
    description: 'High-quality video content helps your brand stand out in a crowded market, boosting visibility and supporting long-term business growth.',
  },
];

const VideoBenefits = () => {
  return (
    <section className="videobenefits-section">
      <div className="videobenefits-inner">
        <h2 className="videobenefits-heading">How can your business get benefit from graphic designing?</h2>

        {/* Row 1 — 3 cards */}
        <div className="videobenefits-row">
          {benefits.slice(0, 3).map((item) => (
            <div className="videobenefits-card" key={item.id}>
              <div className="videobenefits-card__icon-wrap">{icons[item.icon]}</div>
              <h3 className="videobenefits-card__title">{item.title}</h3>
              <p className="videobenefits-card__desc">{item.description}</p>
            </div>
          ))}
        </div>

        {/* Row 2 — 2 cards */}
        <div className="videobenefits-row videobenefits-row--2">
          {benefits.slice(3, 5).map((item) => (
            <div className="videobenefits-card" key={item.id}>
              <div className="videobenefits-card__icon-wrap">{icons[item.icon]}</div>
              {item.title && <h3 className="videobenefits-card__title">{item.title}</h3>}
              {item.description && <p className="videobenefits-card__desc">{item.description}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoBenefits;